import { render } from "./WorkspaceCockpitDialog.vue?vue&type=template&id=ccc0a23e&ts=true"
import script from "./WorkspaceCockpitDialog.vue?vue&type=script&lang=ts"
export * from "./WorkspaceCockpitDialog.vue?vue&type=script&lang=ts"

import "./WorkspaceCockpitDialog.vue?vue&type=style&index=0&id=ccc0a23e&lang=scss"

import exportComponent from "/dati01/var/lib/jenkins/workspace/Sub_Task_Release_CE/knowage-vue/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__